module.exports = __webpack_public_path__ + "static/media/de.85f98c37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/de.svg
// module id = 98
// module chunks = 0